export { Hero } from "./Hero";
export type { HeroProps } from "./Hero";
